import { rest } from 'msw'
const data = require('../data/my-dashboard-setting.json')

export default [
  /**
   * マイダッシュボード一覧
   */
  // rest.get('/swc-api/master/my-dashboard-settings/?user_id=:user_id&node_id=:node_id', (req, res, ctx) => {
  //   // If authenticated, return a mocked user details
  //   const key = req.url.searchParams.get('node_id') == 2 ? 2 : 1
  //   return res(
  //     ctx.status(200),
  //     ctx.json(data[key]),
  //   )
  // }),

  // 下記警告に対応
  // [MSW] Found a redundant usage of query parameters in the request handler URL for "GET /swc-api/master/my-dashboard-settings/?user_id=:user_id&node_id=:node_id". Please match against a path instead and access query parameters in the response resolver function using "req.url.searchParams".
  rest.get('/swc-api/master/my-dashboard-settings/', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    const key = req.url.searchParams.get('node_id') == 2 ? 2 : 1
    return res(
      ctx.status(200),
      ctx.json(data[key]),
    )
  }),

  /**
   * シンプル記録
   */
   rest.post('/swc-api/master/my-dashboard-settings/', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json(
        {
          "id": 1,
          "user_id": 4,
          "node_id": 10,
          "first_flag": false,
          "dashboard_settings": "[]"
          })
      )
  }),

  /**
   * シンプル記録
   */
   rest.patch('/swc-api/master/my-dashboard-settings/:id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json(
        {
          "id": 1,
          "user_id": 4,
          "node_id": 10,
          "first_flag": false,
          "dashboard_settings": "[]"
          })
    )
  }),

    /**
   * シンプル記録
   */
     rest.delete('/swc-api/nodes/:nodeId/maintenance-histories/:maintenanceHistoryId', (req, res, ctx) => {
      // If authenticated, return a mocked user details
      return res(
        ctx.status(200),
        ctx.json(
          {
            "id": 1,
            "user_id": 4,
            "node_id": 10,
            "first_flag": false,
            "dashboard_settings": "[]"
            })
        )
    }),
]
